import React, { useMemo } from 'react'
import Scroll from 'react-scroll'
import getBackgroundsUrlsObj from '../functions/getBackgroundsUrlsObj'
import { SiteSlidebarRight, SiteSlidebarRightSecond } from '../General/SiteSlidebars'
import MovieDetailsContainer from '../MovieDetails'
import MovieInformationContainer from '../MovieInformation'
import { trackMovieDetailsClose, trackMovieDetailsOpen, trackMovieInformationClose, trackMoviePerformanceClose, trackMoviePerformanceOpen } from '../tracking'
import PerformanceSectionContainer from '../PerformancePage/PerformanceSectionContainer'


let Element = Scroll.Element

const SlideActiveItem = ({
    itemLink,
    activeItem,
    activePerformance,
    currentDateActive,
    scrollToPosition,
    eventOrigins,
    moviesData,
    displaySidebarRight,
    displaySidebarRightSecond,
    performancePageOpen,
    detailsOpen,
    isMobile,
    onCloseInformation,
    onOpenDetails,
    onCloseDetails,
    onOpenPerformancePage,
    filterType,
    filterValue,
    onClosePerformancePage,
    toggleMovieDatesOnMobileView
}) => {

    const movieData = activeItem && moviesData.hasOwnProperty(activeItem) ? moviesData[activeItem] : false
    const images = movieData && movieData.hasOwnProperty('images') ? movieData.images : {}

    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(images), 
        [images]
    )

    // ToDO movieData an Komponenten übergeben

    return (
        <>
            <Element name={scrollToPosition + ' openMovieInformation'}></Element>
            {!displaySidebarRight && !performancePageOpen && activeItem && <MovieInformationContainer
                itemID={activeItem}
                filterValue={filterValue}
                filterType={filterType}
                toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                activePerformance={activePerformance}
                moviesData={moviesData}
                itemLink={itemLink}
                detailsOpen={detailsOpen}
                backgroundImage={backgroundsObj.performance}
                isMobile={isMobile}
                trailerImage={backgroundsObj.ambient}
                scrollToPosition={scrollToPosition}
                onOpenDetails={trackMovieDetailsOpen(onOpenDetails, eventOrigins.information)}
                onCloseDetails={trackMovieDetailsClose(onCloseDetails, eventOrigins.information)}
                onCloseInformation={trackMovieInformationClose(onCloseInformation, eventOrigins.information)}
                onOpenIframe={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.information)}
            />}

            {!displaySidebarRight && performancePageOpen && <PerformanceSectionContainer
                filterValue={filterValue}
                filterType={filterType}
                activeItem={activeItem}
                activePerformance={activePerformance}
                moviesData={moviesData}
                isMobile={isMobile}
                backgroundImage={backgroundsObj.performance}
                scrollToPosition={scrollToPosition}
                currentDateActive={currentDateActive}
                toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.performance)}
                onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage, eventOrigins.performance)}
            />}

            <Element name={scrollToPosition + ' movieDetails'}></Element>
            {!displaySidebarRightSecond && activeItem && detailsOpen && <MovieDetailsContainer
                itemID={activeItem}
                isMobile={isMobile}
                trailerImage={backgroundsObj.ambient}
                filterValue={filterValue}
                filterType={filterType}
                moviesData={moviesData}
                backgroundImage={backgroundsObj.details}
                scrollToPosition={scrollToPosition}
                onCloseDetails={trackMovieDetailsClose(onCloseDetails, eventOrigins.details)}
            />}

            {displaySidebarRight && activeItem && <SiteSlidebarRight>
                <MovieInformationContainer
                    isMobile={isMobile}
                    itemID={activeItem}
                    moviesData={moviesData}
                    itemLink={itemLink}
                    hideCinemaSelector={true}
                    filterValue={filterValue}
                    filterType={filterType}
                    detailsOpen={detailsOpen}
                    backgroundImage={backgroundsObj.performance}
                    trailerImage={backgroundsObj.ambient}
                    scrollToPosition={scrollToPosition}
                    onOpenDetails={trackMovieDetailsOpen(onOpenDetails, eventOrigins.informationSlidebar)}
                    onCloseDetails={trackMovieDetailsClose(onCloseDetails, eventOrigins.informationSlidebar)}
                    onCloseInformation={trackMovieInformationClose(onCloseInformation, eventOrigins.informationSlidebar)}
                    toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                    currentDateActive={currentDateActive}
                    onOpenIframe={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.informationSlidebar)}
                />
            </SiteSlidebarRight>}

            {displaySidebarRightSecond && performancePageOpen && <SiteSlidebarRightSecond>
                <PerformanceSectionContainer
                    activeItem={activeItem}
                    activePerformance={activePerformance}
                    isMobile={isMobile}
                    performancePageMovieTimes={true}
                    filterValue={filterValue}
                    filterType={filterType}
                    moviesData={moviesData}
                    backgroundImage={backgroundsObj.performance}
                    scrollToPosition={scrollToPosition}
                    currentDateActive={currentDateActive}
                    toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                    onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.performanceSlidebar)}
                    onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage, eventOrigins.performanceSlidebar)}
                />
            </SiteSlidebarRightSecond>}

            {displaySidebarRightSecond && activeItem && detailsOpen && <SiteSlidebarRightSecond>
                <MovieDetailsContainer
                    itemID={activeItem}
                    trailerImage={backgroundsObj.ambient}
                    isMobile={isMobile}
                    moviesData={moviesData}
                    filterValue={filterValue}
                    filterType={filterType}
                    backgroundImage={backgroundsObj.details}
                    scrollToPosition={scrollToPosition}
                    onCloseDetails={trackMovieDetailsClose(onCloseDetails, eventOrigins.detailsSlidebar)}
                />
            </SiteSlidebarRightSecond>}
        </>
    )

}

export default SlideActiveItem